import { type FunctionComponent } from 'react';

import { InputGroup } from '@blueprintjs/core';

import { testAttribute } from '../../../../util/Util';

interface TextFilterInputProps {
  value: string;
  onChange: (newValue: string) => void;
  label?: string;
  filterKey: string;
}

export const TextFilterInput: FunctionComponent<TextFilterInputProps> = ({ value, onChange, label, filterKey }) => (
  <>
    <span className="lib-table-filter__label">{label}</span>
    <InputGroup
      data-test-id={testAttribute('txfi', 'table-filter.text-input', filterKey)}
      value={value ?? ''}
      type="text"
      fill
      onChange={(event: any) => onChange(event.target.value)}
    />
  </>
);
